<template>
  <div v-if="!model.disabled">
    <div class="smart-form">
      <w-label
        :title="title"
        :show-label="showLabel"
        :model="model"
        :description="description"
        :next-number="nextNumber"
        :bold-label="boldLabel"
      >
        <template v-slot:description>
          <slot name="description" />
        </template>
      </w-label>
    </div>

    <div ref="items">
      <div v-for="(item, index) in modelArray" :key="'item_' + index">
        <div style="margin-bottom: 0;" :class="'jarviswidget jarviswidget-color-' + color">
          <header>
            <span class="widget-icon">
              <i :class="icon" />
            </span>

            <h2 style="width: auto;">
              <slot name="headerTitle">
                {{headerTitle}}&nbsp;
                <w-preview
                  v-if="item.$item.Nazwa && item.$item.Nazwa.$model"
                  :model="item.$item.Nazwa"
                />

                <w-preview
                  v-else-if="item.$item.Name && item.$item.Name.$model"
                  :model="item.$item.Name"
                />

                <span v-else-if="showCounter">{{ index + 1 }}.</span>
              </slot>&nbsp;
              <span
                v-if="modelArray && modelArray.length && showHideBttns"
                @click="toggleItem(index)"
                class="pull-right pointer"
              >
                <u>
                  <i>{{hideItems[index] ? '(rozwiń)' : '(zwiń)'}}</i>
                </u>
                &nbsp;
                <i
                  :class="'fa ' + (hideItems[index] ? 'fa-caret-down' : 'fa-caret-up')"
                ></i>
              </span>
            </h2>
          </header>

          <div v-show="!hideItems[index]" role="content">
            <slot :item="item" :index="index" />

            <br />
          </div>
        </div>

        <w-alert
          v-show="hideItems[index] && validationCase"
          header
          class="smart-form"
          alert-type="danger"
        >{{validationMessage}}</w-alert>

        <br />
      </div>
    </div>

    <div v-if="modelArray && modelArray.length > 1 && showHideBttns" ref="menu" class="smart-form">
      <slot name="menu" />

      <br />

      <button
        v-show="hideItems.filter((item) => item).length != model.$items.length"
        @click="setVisibility(true)"
        class="btn btn-default margin-right-5"
      >
        <i class="fa fa-fw fa-caret-square-o-up"></i>&nbsp;Zwiń wszystkich
      </button>

      <button
        v-show="hideItems.includes(true)"
        @click="setVisibility(false)"
        class="btn btn-default"
      >
        <i class="fa fa-fw fa-caret-square-o-down"></i>&nbsp;Rozwiń wszystkich
      </button>
    </div>
  </div>
</template>

<script>
import modelMixin from '../mixins/modelMixin';
import titleMixin from '../mixins/titleMixin';

export default {
  name: 'w-jarvis',
  mixins: [modelMixin, titleMixin],
  props: {
    hideItems: {
      type: Array,
      default: () => []
    },
    headerTitle: {
      type: String,
      default: '',
      required: false
    },
    validationCase: {
      type: Boolean,
      default: false,
      required: false
    },
    showHideBttns: {
      type: Boolean,
      default: true,
      required: false
    },
    showCounter: {
      type: Boolean,
      default: true,
      required: false
    },
    validationMessage: {
      type: String,
      default: '',
      required: false
    },
    icon: {
      type: String,
      default: 'fa fa-user',
      required: false
    },
    color: {
      type: String,
      default: 'teal',
      required: false
      //http://www.szablony.infocity.pl/smartadmin/1.4/#ajax/widgets.html
    }
  },
  methods: {
    toggleItem(index) {
      this.$set(this.hideItems, index, !this.hideItems[index]);
    },
    setVisibility(value) {
      if (this.model && this.model.$items && this.model.$items.length)
        for (let i = 0; i < this.model.$items.length; i++) {
          this.$set(this.hideItems, i, value);
        }
    }
  },
  computed: {
    modelArray() {
      var result = this.model.$items && this.model.$schema.type === 'array' ? this.model.$items : [{$item: this.model}];
      return result;
    }
  }
};
</script>